import { render, staticRenderFns } from "./blog10.vue?vue&type=template&id=3a5cae10"
import script from "./blog10.vue?vue&type=script&lang=js"
export * from "./blog10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports